import { requiredString } from "components/form/utils";
import * as z from "zod";

const entrySchema = z.object({
  tag: requiredString(),
  logged_hours: z
    .string()
    .min(1, "Hours are required")
    .refine(
      (value) => {
        const parsedValue = parseFloat(value);
        return (
          !isNaN(parsedValue) && parsedValue > 0 && parsedValue % 0.5 === 0
        );
      },
      {
        message:
          "Please enter time in 30-minute increments (0.5, 1, 1.5, etc.)",
      },
    )
    .default("0.5"),
  description: z.string().min(1, "Description is required"),
});

export const timesheetLogSchema = z.object({
  date: z.string().nonempty("Date is required"),
  project: z
    .string()
    .min(1, "Project is required")
    .nonempty("Project cannot be empty"),
  job: z.string().min(1, "Job is required").nonempty("Job cannot be empty"),
  milestone: z.string().optional(),
  entries: z.array(entrySchema).min(1, "At least one entry is required"),
});
